module.exports = __webpack_public_path__ + "static/media/mother-earth-day.7133fa5f.png";